import FormPolyfill from 'form-association-polyfill/dist/form-association-polyfill-with-shims';

// Start!
FormPolyfill.register();
